<template>
  <div class="uniqueTable com-table-list">
    <a-table
      :columns="computedColumns"
      :components="components"
      v-bind="$attrs"
      v-on="$listeners"
      :pagination="false"
      :style="{minHeight:(showMinHeight == true?520+'px':'')}"
      border
    >
      <template
        v-for="column in columns"
        :slot="column.scopedSlots ? column.scopedSlots.customRender : ''"
        slot-scope="text, record"
      >
        <slot
          :name="column.scopedSlots ? column.scopedSlots.customRender : ''"
          v-bind="record"
        ></slot>
      </template>
    </a-table>
  </div>
</template>
<script>
import Vue from 'vue';
import VueDraggableResizable from 'vue-draggable-resizable';
Vue.component('vue-draggable-resizable', VueDraggableResizable);
// 公共的table 封装了hover出现省略号 显示全部，加上样式
export default {
  name: 'ComTableList',
  props: {
    // // 接收传递的自定义操作功能
    columns: {
      type: Array
      // default: () => ({})
    },
    showMinHeight:{
      type:Boolean,
      default:false
    }
  },
  data(){
    this.components = {
      header: {
        cell: (h, props, children) => {
          const { key, ...restProps } = props
          const col = this.columns.find(col => {
            const k = col.dataIndex || col.key
            return k == key
          })
          if (!col || !col.width ||col.scopedSlots) {
            return h('th', { ...restProps }, [...children])
          }
          let numberX='';
          if(typeof col.width === 'string'){ //字符string去掉px
            numberX=Number(col.width.replace(/[^0-9]/ig, ''))
          }else{ //可能是number或者一个对象
            numberX=col.width;
          }
          const dragProps = {
            key: col.dataIndex || col.key,
            class: 'table-draggable-handle',
            attrs: {
              w: 10,
              x: numberX,
              z: 1,
              axis: 'x',
              draggable: true,
              resizable: false
            },
            on: {
              dragging: (x) => {
                if(x<=50){
                  x=50
                }
                //可能x的轴为负的
                col.width =Math.max(x,1);
                  // Math.max(x,1);
              }
            }
          }
          const drag = h('vue-draggable-resizable', { ...dragProps })
          return h('th', { ...restProps, class: 'resize-table-th' }, [...children, drag])
        }
      }
    }
    return {
    }
  },
  computed: {
    computedColumns() {
      return this.columns.map(column => {
        if (column.scopedSlots) {
          return column;
        } else {
          return {
            ...column,
            ellipsis:true
            // customRender:
            //   column.customRender ||
            //   (text => ({
            //     children: this.$createElement(
            //       'a-tooltip',
            //       { props: { title: text, placement: 'topLeft' } },
            //       [
            //         this.$createElement(
            //           'div',
            //           {
            //             style: {
            //               width: column.width || '100%',
            //               overflow: 'hidden',
            //               textOverflow: 'ellipsis',
            //               whiteSpace: 'nowrap'
            //             }
            //           },
            //           [text]
            //         )
            //       ]
            //     )
            //   }))
        
        };
        }
      });
    }
  }
};
</script>
<style lang="less">
.com-table-list{
  // overflow: scroll;
}
.resize-table-th {
    position: relative;
    .table-draggable-handle {
      transform: none !important;
      position: absolute;
      height: 100% !important;
      bottom: 0;
      left: auto !important;
      right: -5px;
      cursor: col-resize;
      touch-action: none;
    }
}
</style>